import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { NoAlerts } from '../NoAlerts/NoAlerts';
import { WarningsXsBlock } from './WarningsXSBlock';
import { getWarningsNumber } from '../../../../utils/utils';
import { useInventorySubscription } from '../useInventorySubscription';
const useStyles = makeStyles(() => ({
    contentContainer: {
        padding: 20,
        height: 'calc(100% - 41px)',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
}));
export const InventoryWidgetXS = () => {
    const classes = useStyles();
    const inventory = useInventorySubscription();
    const { criticalCount, earlyCount } = getWarningsNumber(inventory);
    const isEmpty = !criticalCount && !earlyCount;
    return (React.createElement("div", { className: classes.contentContainer }, isEmpty ? React.createElement(NoAlerts, null) : React.createElement(WarningsXsBlock, { criticalCount: criticalCount, earlyCount: earlyCount })));
};
//# sourceMappingURL=InventoryWidgetXS.js.map